import { createSlice } from '@reduxjs/toolkit'

import { ClientsType } from '../../actions/types'
import {
  createClient,
  deleteClient,
  getClients,
  getCurrentClient,
  updateClient,
} from '../../actions/clientsAction'

interface IClientsState {
  clients: ClientsType[]
  currentClient: ClientsType | null
  isLoading: boolean
  error: any
}

const initialState: IClientsState = {
  clients: [],
  currentClient: null,
  isLoading: false,
  error: '',
}

export const clientSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    clearClientError(state) {
      state.error = ''
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getClients.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getClients.fulfilled, (state, action) => {
      state.isLoading = false
      state.clients = action.payload
      state.error = ''
    })
    builder.addCase(getClients.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })

    builder.addCase(getCurrentClient.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getCurrentClient.fulfilled, (state, action) => {
      state.isLoading = false
      state.currentClient = action.payload
      state.error = ''
    })
    builder.addCase(getCurrentClient.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })

    builder.addCase(createClient.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(createClient.fulfilled, (state, action) => {
      state.isLoading = false
      state.clients.push(action.payload)
      state.error = ''
    })
    builder.addCase(createClient.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })

    builder.addCase(deleteClient.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(deleteClient.fulfilled, (state, action) => {
      state.isLoading = false
      state.clients = state.clients.filter((client) => client.id !== action.payload)
      state.error = ''
    })
    builder.addCase(deleteClient.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })

    builder.addCase(updateClient.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(updateClient.fulfilled, (state, action) => {
      state.isLoading = false
      state.clients = state.clients.map((client) =>
        client.id === action.payload.id ? action.payload : client,
      )
      state.error = ''
    })
    builder.addCase(updateClient.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })
  },
})

export const { clearClientError } = clientSlice.actions
export const clientReducer = clientSlice.reducer
